// Survey counter: animate numbers when they come into view
$(document).ready(function () {
	if ($(".survey-item").length === 0) {
		return;
	}

	$(".survey-item .value").each(function () {
		var $this = $(this);
		$this.data("original", $this.text());
		$this.data("animated", false);
	});

	function animateCounter($element) {
		if ($element.data("animated")) {
			return;
		}

		var originalText = $element.data("original");
		var targetNumber = 0;
		var suffix = "";

		if (originalText.includes("%")) {
			targetNumber = parseInt(originalText.replace("%", ""));
			suffix = "%";
		} else if (originalText.includes("+")) {
			targetNumber = parseInt(originalText.replace("+", "").replace(",", ""));
			suffix = "+";
		} else {
			targetNumber = parseInt(originalText);
		}

		if (isNaN(targetNumber)) {
			return;
		}

		$element.data("animated", true);
		var $surveyItem = $element.closest(".survey-item");

		$surveyItem.addClass("counter-animating");
		$element.addClass("counter-animating");

		$({ countNum: 0 }).animate(
			{ countNum: targetNumber },
			{
				duration: 2000,
				easing: "swing",
				step: function () {
					var currentNum = Math.floor(this.countNum);
					if (suffix === "+") {
						$element.text(currentNum.toLocaleString() + suffix);
					} else {
						$element.text(currentNum + suffix);
					}
				},
				complete: function () {
					$element.text(originalText);
					$element.removeClass("counter-animating");
					$surveyItem.removeClass("counter-animating");
				},
			}
		);
	}

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var $value = $(entry.target).find(".value");
					animateCounter($value);
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.5, rootMargin: "0px 0px -100px 0px" }
	);

	$(".survey-item").each(function () {
		observer.observe(this);
	});
});
